export class NavTab {
    constructor(
        public id: number,
        public name: string,
        public active: boolean
    ) {
    }
}
